module.exports = __webpack_public_path__ + "img/Family-photo.3488c2d6.png";